import { ResponsiveContainer, CartesianGrid, Area, AreaChart } from 'recharts';
import { cm } from 'src/utils/classNames';
import SkeletonValuePlaceholder from '../SkeletonValuePlaceholder/SkeletonValuePlaceholder';
import { getColorVar } from 'src/utils/theme/colorVars';

const data = [
	{ name: 'A', value: 200 },
	{ name: 'B', value: 300 },
	{ name: 'C', value: 250 },
	{ name: 'D', value: 278 },
	{ name: 'E', value: 359 },
	{ name: 'F', value: 329 },
	{ name: 'G', value: 439 },
	{ name: 'H', value: 600 },
];

export const LoadingChart = ({
	yAxisLabelClassName = 'w-12 h-4',
	xAxisLabelClassName = 'flex-1 h-4',
	className,
}: {
	yAxisLabelClassName?: string;
	xAxisLabelClassName?: string;
	className?: string;
}) => {
	const strokeColor = getColorVar('button-disabled');

	return (
		<div className={cm('h-[200px] w-full', className)}>
			<div className="flex h-full w-full flex-col gap-2">
				<div className="flex grow gap-2">
					<div className="flex flex-col justify-between">
						{/** Y-axis loading skeletons */}
						{Array.from({ length: 5 }).map((_, index) => (
							<SkeletonValuePlaceholder
								key={index}
								className={yAxisLabelClassName}
								loading
							/>
						))}
					</div>
					<div className="grow animate-pulse">
						{/** Faux Graph */}
						<ResponsiveContainer width="100%" height="100%">
							{/* @ts-ignore */}
							<AreaChart data={data} overflow={'visible'}>
								<CartesianGrid stroke={strokeColor} />
								<Area
									type="monotone"
									dataKey={'value'}
									strokeWidth={2}
									dot={false}
									className="z-50"
									stroke={strokeColor}
									fill={strokeColor}
								/>
							</AreaChart>
						</ResponsiveContainer>
					</div>
				</div>

				<div className="flex w-full gap-2 py-1">
					<div className={cm(yAxisLabelClassName, 'shrink-0')}>
						{/** Faux Y-axis */}
					</div>
					<div className="flex w-full justify-between gap-2">
						{/** X-axis loading skeletons */}
						{Array.from({ length: 7 }).map((_, index) => (
							<SkeletonValuePlaceholder
								key={index}
								className={xAxisLabelClassName}
								loading
							/>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};
